export const CATEGORY_FILTERS = "Category Filters";

export const ARTICLE_LIST_INTERVAL = 4;

export const ALL_CATEGORY_DATA = {
  uri: "/category/all/",
  name: "All",
  id: "all",
};

export const CATEGORY_ARTICLE_LIST_DATA = {
  CATEGORY_NAME: "t0",
  CATEGORY_URI: "t1",
  PAGE_NUMBER: "t2",
};

export const BUZZ_ARTICLES_LIST_CAROUSEL_FLOW =
  "BUZZ_ARTICLES_LIST_CAROUSEL";

export const BUZZ_ARTICLES_LIST_FLOW = "BUZZ_ARTICLES_LIST";
export const BUZZ_CATEGORY_ARTICLES_LIST_PAGINATION_FLOW =
  "BUZZ_CATEGORY_ARTICLES_LIST_PAGINATION";
export const POPULAR_POST_FLOW =
  "BUZZ_CATEGORY_ARTICLE_LIST_POPULAR_POSTS";

export const ARTICLE_LIST_DATA = {
  CATEGORY: "t3",
  URL: "t4",
  PAGE_NUMBER: "t5",
};
